import { Injectable } from '@angular/core';
import { APIsEndPoints  } from './../utilities/apis.endpoints';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  url = APIsEndPoints.GET_SETTINGS;
  emailAddress: any[];
  activeSafetyChampionsSurveyEmailAddresses: any[];
  safetyChampionsSurveyActivePeriod:string;
  constructor(
    private http: HttpClient,
  ) { }

  getSubmitterDetailViewStatus(){
    return this.http.get(`${this.url}`);
  }

  setEmailAddress(email: any[]){
    this.emailAddress = email;
    console.log('email set ', this.emailAddress);
  }

  getSafetyChampionsSurveyActiveEmailAddresses(){
    console.log('getSafetyChampionsSurveyActiveEmailAddresses ', this.activeSafetyChampionsSurveyEmailAddresses);
    return this.activeSafetyChampionsSurveyEmailAddresses;
  }
  setSafetyChampionsSurveyActiveEmailAddresses(email: any[]){
    this.activeSafetyChampionsSurveyEmailAddresses = email;
    console.log('activeSafetyChampionsSurveyEmailAddresses set ', this.activeSafetyChampionsSurveyEmailAddresses);
  }

  getEmailAddress(){
    console.log('email get ', this.emailAddress);
    return this.emailAddress;
  }
  setSubmitterDetailSetting (settingData){
    console.log('set Submmitted Detail ',settingData);
    return this.http.patch(`${this.url}`,{settingData});
  }

  getsafetyChampionsSurveyActivePeriod(){
    console.log('safetyChampionsSurveyActivePeriod get ', this.safetyChampionsSurveyActivePeriod);
    return this.safetyChampionsSurveyActivePeriod;
  }
  setsafetyChampionsSurveyActivePeriod (safetyChampionsSurveyActivePeriod){
    this.safetyChampionsSurveyActivePeriod=safetyChampionsSurveyActivePeriod;
    console.log('set safetyChampionsSurveyActivePeriod ',safetyChampionsSurveyActivePeriod);
  }


  getLastCompletedQuarter() {
    const now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth();
    let currentQuarter = Math.floor(month / 3) + 1;
    let lastQuarter = currentQuarter - 1;
    if (lastQuarter === 0) {
      lastQuarter = 4;
      year -= 1;
    }
    return `Q${lastQuarter}-${year}`;
  }
    resetVotingAndShortlisting(event:any) {
    return this.http.post(`${APIsEndPoints.RESET_FOR_SHORTLISTING}`,{}).subscribe(
      () => {
        alert('Reset successful!');
        // Optionally reload data or update UI
        event.target.checked = false;
      },
      (err) => {
        alert('Reset failed.');
        console.error(err);
        
      }
    );
  }
}
